import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { TProcessBoardsActionType } from './process-boards.models';
import * as ProcessBoardsActions from './process-boards.actions';
import { of, from } from 'rxjs';
import { switchMap, map, catchError, take, finalize, exhaustMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProcessBoardsEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchCapacityBoardListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessBoardsActionType.FetchCapacityBoardListing),
      exhaustMap((action: ProcessBoardsActions.FetchCapacityBoardListing) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.plani8DataService.getCapacityBoard(action.payload).pipe(
              map((res) => new ProcessBoardsActions.FetchCapacityBoardListingSuccess(res)),
              catchError(() => of(new ProcessBoardsActions.FetchCapacityBoardListingFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );

  fetchPlanningBoardListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessBoardsActionType.FetchPlanningBoardListing),
      exhaustMap((action: ProcessBoardsActions.FetchPlanningBoardListing) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.plani8DataService.getPlanningBoard(action.payload).pipe(
              map((res) => new ProcessBoardsActions.FetchPlanningBoardListingSuccess(res)),
              catchError(() => of(new ProcessBoardsActions.FetchPlanningBoardListingFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );

  fetchOrderTimelineViewBoardListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessBoardsActionType.FetchOrderTimelineViewBoardListing),
      exhaustMap((action: ProcessBoardsActions.FetchOrderTimelineViewBoardListing) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.plani8DataService.getOrderTimelineViewBoard(action.payload).pipe(
              map((res) => new ProcessBoardsActions.FetchOrderTimelineViewBoardListingSuccess(res)),
              catchError(() => of(new ProcessBoardsActions.FetchOrderTimelineViewBoardListingFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );
}
